export enum SfxFamily {
    Buildings = 'buildings',
    Devices = 'devices',
    Environment = 'environment',
    Fauna = 'fauna',
    Industrial = 'industrial',
    Misc = 'misc',
    People = 'people',
    Technology = 'technology',
    Transport = 'transport',
    Warfare = 'warfare',
}
